module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-play-box tv-video"
  }, [(_vm.pageType !== 'vip') ? _c('div', {
    staticClass: "jin-play-box__h"
  }, [_c('div', {
    staticClass: "jin-play-box__l"
  }, [_c('h3', {
    staticClass: "jin-play-box__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "jin-play-box__r"
  }, [_c('jin-popover', {
    ref: "qrcodePopover",
    attrs: {
      "popper-class": "jin-qrcode-popover",
      "placement": "bottom-end",
      "open-delay": 300,
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "jin-qrcode"
  }, [_c('dl', [_c('dt', [_c('p', [_vm._v("扫描右侧二维码")]), _vm._v(" "), _c('p', [_vm._v("畅享手机看直播")])]), _vm._v(" "), _c('dd', [(_vm.liveType === 'tradingNew') ? _c('img', {
    attrs: {
      "src": require("../../../assets/img/trading_qrcode.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../assets/img/tv_qrcode.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:qrcodePopover",
      arg: "qrcodePopover"
    }],
    staticClass: "jin-play-box__btn jin-play-box__phone"
  }, [_c('icon', {
    attrs: {
      "type": "phone"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tv-video__b"
  }, [(!_vm.repeatImageUrl) ? [(_vm.liveUrl) ? _c('div', [(_vm.isMobile) ? _c('div', {
    staticClass: "tv-video__box"
  }, [_c('video', {
    attrs: {
      "id": "J_tv_video_type",
      "width": "100%",
      "height": "100%",
      "controls": "controls",
      "webkit-playsinline": "",
      "playsinline": "",
      "x-webkit-airplay": "allow",
      "x5-playsinline": "",
      "autoplay": "autoplay"
    }
  })]) : _c('div', {
    staticClass: "tv-video__box",
    attrs: {
      "id": "J_tv_box_type"
    }
  })]) : _c('div', {
    staticClass: "tv-video__poster"
  }, [_c('img', {
    attrs: {
      "src": _vm.posterUrl
    }
  })])] : _c('div', {
    staticClass: "tv-video__poster"
  }, [_c('img', {
    attrs: {
      "src": _vm.repeatImageUrl
    }
  }), _vm._v(" "), (_vm.repeatImageUrl && _vm.isVipPageAndNotAVip) ? _c('a', {
    staticClass: "tv-video__vip-link",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toVipPage
    }
  }) : _c('jin-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showRepeat
    }
  }, [_c('icon', {
    attrs: {
      "type": "repeat-video"
    }
  }), _vm._v(" "), _c('span', [_vm._v("点击这里收看最近一期节目")])], 1)], 1), _vm._v(" "), (_vm.isShowNextTV && false) ? _c('div', {
    staticClass: "tv-video__mask"
  }, [_c('div', {
    staticClass: "tv-video-tips"
  }, [_c('h4', {
    staticClass: "tv-video-tips__h"
  }, [_vm._v("\n          温馨提示：" + _vm._s(_vm.nowDatas.prevue.title) + "即将直播\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "tv-video-tips__b"
  }, [_c('jin-button', {
    on: {
      "click": _vm.closeNextTV
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('jin-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showNextTV
    }
  }, [_vm._v("提前进入")])], 1)])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "tv-video__f"
  }, [_c('div', {
    staticClass: "tv-video__l"
  }, [_c('div', {
    staticClass: "tv-video-info"
  }, [(_vm.getEmceeInfo('pic')) ? _c('img', {
    staticClass: "tv-video-info__avatar",
    attrs: {
      "src": _vm.getEmceeInfo('pic'),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getEmceeInfo('nick')) ? _c('span', {
    staticClass: "tv-video-info__text"
  }, [_vm._v("关注" + _vm._s(_vm.getEmceeInfo('nick')))]) : _vm._e(), _vm._v(" "), (_vm.getEmceeInfo('weibo')) ? _c('a', {
    staticClass: "tv-video-info__btn is-weibo",
    attrs: {
      "target": "_blank",
      "href": _vm.getEmceeInfo('weibo')
    }
  }, [_c('icon', {
    attrs: {
      "type": "weibo"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('jin-popover', {
    ref: "wechatPopover",
    attrs: {
      "placement": "right",
      "trigger": "hover"
    }
  }, [_c('img', {
    attrs: {
      "width": "200",
      "src": _vm.wechatUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "popover",
      rawName: "v-popover:wechatPopover",
      arg: "wechatPopover"
    }],
    staticClass: "tv-video-info__btn is-wechat"
  }, [(_vm.wechatUrl) ? _c('icon', {
    attrs: {
      "type": "wechat"
    }
  }) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tv-video-share"
  }, [_c('share-button', {
    attrs: {
      "dir": "vertical"
    }
  })], 1)]), _vm._v(" "), _c('vip-dialog', {
    model: {
      value: (_vm.showVipDialog),
      callback: function($$v) {
        _vm.showVipDialog = $$v
      },
      expression: "showVipDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed0e7bda","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tv/modules/Content/src/videoForType.vue
// module id = Fcz0
// module chunks = 2 3 4 6 7 8 9